import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { DataGrid } from '@mui/x-data-grid';
import Swal from 'sweetalert2';
import {Link, useParams} from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../../Univ.js'

function OtNotes(props){

  const {id} = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [surData, setSurData] = useState([]);
  const [postinDateTime, setPostinDateTime] = useState();
  const [postoutDateTime, setPostoutDateTime] = useState();
  const [preDateTime, setPreDateTime] = useState();
  const [postDateTime, setPostDateTime] = useState();
  const [anesDateTime, setAnesDateTime] = useState();

  const [otData,setotData]=useState({
        "pre_time":'',
        "pre_notes":'',
        "post_in":'',
        "post_out":'',
        "anes_time":'',
        "anes_notes":'',
        "post_time":'',
        "post_notes":'',
        "status":'',
        "addedby":'',
        "ip_add":'',
    });

  useEffect(() => {
    fetchsurData();
  }, []);

  function fetchsurData() {
    axios.get(baseUrl + "update-surgery/" + id + "/")
      .then(response => {
        setSurData([response.data]);
      })
      .catch(error => {
        console.log(error);
      });
  }
    const handlepiDateTimeChange = (datetime) => {
        setPostinDateTime(datetime);
    };
    const handlepoDateTimeChange = (datetime) => {
        setPostoutDateTime(datetime);
    };
    const handlepreDateTimeChange = (datetime) => {
      setPreDateTime(datetime);
    };

    const handlepostDateTimeChange = (datetime) => {
        setPostDateTime(datetime);
    };
    const handleanesDateTimeChange = (datetime) => {
        setAnesDateTime(datetime);
    };

    const inputHandler = (event) => {
      const { name, value } = event.target;
      const updatedotData = { ...otData, [name]: value };
        setotData(updatedotData);
    };

  const formSubmit = (e) => {
  e.preventDefault();
  const pre_notes = document.getElementById("pre_notes").value;
  const pre_time = document.getElementById("pre_time").value;
  const post_time = document.getElementById("post_time").value;
  const post_notes = document.getElementById("post_notes").value;
  const post_in = document.getElementById("post_in").value;
  const post_out = document.getElementById("post_out").value;
  const anes_notes = document.getElementById("anes_notes").value;
  const anes_time = document.getElementById("anes_time").value;

  const formData = new FormData();

      if (pre_notes) {
        formData.append('pre_notes', pre_notes);
      }
      if (pre_time) {
        formData.append('pre_time', pre_time);
      }
      if (post_time) {
        formData.append('post_time', post_time);
      }
      if (post_notes) {
        formData.append('post_notes', post_notes);
      }
      if (post_in) {
        formData.append('post_in', post_in);
      }
      if (post_out) {
        formData.append('post_out', post_out);
      }
      if (anes_notes) {
        formData.append('anes_notes', anes_notes);
      }
      if (anes_time) {
        formData.append('anes_time', anes_time);
      }
      formData.append('status', '1');
      formData.append('addedby', userName);
      formData.append('ip_add', ipAddress);
          formData.append('location', userLocation);

      axios.put(`${baseUrl}update-surgery/${id}/`, formData)
        .then(response => {
          if (response.status === 200 || response.status === 201) {
            Swal.fire({
              title: 'New Surgery has been added.',
              icon: 'success',
              timer: 5000,
              showConfirmButton: false
            });
            setTimeout(() => {
              window.location.href = '/ot-notes-list/';
            }, 3000);
          }
        })
        .catch(error => {
          console.log(error);
          Swal.fire(
            'Error!',
            'Failed to add min entry. Please try again later.',
            'error'
          );
        });
    };



    return (
    <section className="container mt-4">
     <h3 className="text-center" style={{ color: 'black', backgroundColor: '#e5eaef', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <i className="fa-solid fa-stethoscope" aria-hidden="true" style={{ color: 'red' }}></i>
      Primary Consultant -  Dr.{surData.map(row => row.ip.primary_consult.consultant)}
    </h3>
    <table className="erp-table-modern">
        <thead>
        <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
          <th>Patient</th>
          <th>IP ID</th>
          <th>Patient ID</th>
          <th>Patient Name</th>
          <th>Gender</th>
          <th>D.O.B/Age</th>
          <th>Mobile</th>
          <th>Regd. On</th>
        </tr>
      </thead>

      <tbody>
        {surData.map((patientData, index) => (
          <tr >
          <td><img src={patientData.ip.pat.profile_pic} alt="Thumbnail" className="thumbnail" style={{width:120, height:60}}/></td>
            <td>{patientData.ip.ip_id}</td>
            <td>{patientData.ip.pat.pat_id}</td>
            <td>{patientData.ip.pat.patient}</td>
            <td>{patientData.ip.pat.gender}</td>
            <td>{patientData.ip.pat.age}</td>
            <td>{patientData.ip.pat.mobile}</td>
            <td>{patientData.ip.admit_date}</td>
          </tr>
        ))}
      </tbody>
    </table>
  <div >
  <h3 className="text-center" style={{ color: 'black', backgroundColor: '#e5eaef', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <i className="fa-solid fa-scissors" aria-hidden="true" style={{ color: 'red' }}></i>
      OT Request
    </h3>
      <form>
       <div className="row">
       <div className="col-md-2 ms-1">
          <label htmlFor="Pre OP Time" className="form-label">Pre OP Note Time : </label>
          <DatePicker className="form-control" name="pre_time" id="pre_time"
                onChange={handlepreDateTimeChange.bind(this)}
                selected={surData.length > 0 && surData[0].pre_time ? new Date(surData[0].pre_time) : null || preDateTime}
                dateFormat="yyyy-MM-dd h:mm"
                showTimeSelect
                timeIntervals={15}
                timeCaption="Time"
            />
        </div>
        <div className="col-md-3 ms-1">
        <label htmlFor="Notes" className="form-label">Pre Operative Notes : </label>
          <textarea
          className="no-comma form-control"
          tabIndex="0"
          name="pre_notes"
          id="pre_notes"
          rows={7} // Increase the number of rows to 4
          cols={90} // Increase the number of columns to 30
          defaultValue={surData.length > 0 ? surData[0].pre_notes : ''}
        ></textarea>
        </div>
        </div>
        <div className="row">
       <div className="col-md-2 ms-1">
          <label htmlFor="Pre OP Time" className="form-label">Anesthesia Time : </label>
          <DatePicker className="form-control" name="anes_time" id="anes_time"
                onChange={handleanesDateTimeChange}
                selected={surData.length > 0 && surData[0].anes_time ? new Date(surData[0].anes_time) : null || anesDateTime}
                dateFormat="yyyy-MM-dd h:mm"
                showTimeSelect
                timeIntervals={15}
                timeCaption="Time"
            />
        </div>
        <div className="col-md-3 ms-1">
        <label htmlFor="Notes" className="form-label">Anesthesia Notes : </label>
          <textarea
          className="no-comma form-control"
          tabIndex="0"
          name="anes_notes"
          id="anes_notes"
          rows={7} // Increase the number of rows to 4
          cols={90} // Increase the number of columns to 30
          defaultValue={surData.length > 0 ? surData[0].anes_notes : ''}
        ></textarea>
        </div>
        </div>
        <div className="row">
        <div className="col-md-2 ms-1">
          <label htmlFor="Post In Time" className="form-label">Post In Time : </label>
          <DatePicker className="form-control" name="post_in" id="post_in"
                selected={surData.length > 0 && surData[0].post_in ? new Date(surData[0].post_in) : null || postinDateTime}
                onChange={handlepiDateTimeChange}
                dateFormat="yyyy-MM-dd h:mm"
                showTimeSelect
                timeIntervals={15}
                timeCaption="Time"
            />
        </div>
        <div className="col-md-2 ms-1">
          <label htmlFor="Post Out Time" className="form-label">Post Out Time : </label>
          <DatePicker className="form-control" name="post_out" id="post_out"
                selected={surData.length > 0 && surData[0].post_out ? new Date(surData[0].post_out) : null || postoutDateTime}
                onChange={handlepoDateTimeChange}
                dateFormat="yyyy-MM-dd h:mm"
                showTimeSelect
                timeIntervals={15}
                timeCaption="Time"
            />
        </div>
       </div>
        <div className="row">
        <div className="col-md-2 ms-1">
          <label htmlFor="Post OP Time" className="form-label">Post OP Note Time : </label>
          <DatePicker className="form-control" name="post_time" id="post_time"
                selected={surData.length > 0 && surData[0].post_time ? new Date(surData[0].post_time) : null || postDateTime}
                onChange={handlepostDateTimeChange}
                dateFormat="yyyy-MM-dd h:mm"
                showTimeSelect
                timeIntervals={15}
                timeCaption="Time"
            />
        </div>
       <div className="col-md-3 ms-1">
        <label htmlFor="Notes" className="form-label">Post Operative Notes : </label>
          <textarea
          className="no-comma form-control"
          tabIndex="0"
          name="post_notes"
          id="post_notes"
          rows={7} // Increase the number of rows to 4
          cols={90} // Increase the number of columns to 30
          defaultValue={surData.length > 0 ? surData[0].post_notes : ''}
        ></textarea>
        </div>
        </div>
      <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}
        className='ms-5' >
          <button type="button" onClick={formSubmit} className="btn btn-primary mt-4">Submit</button>
        </div>
      </form>

  </div>
    </section>
    )
}

export default OtNotes;